import {
  ArrowPathIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import { VoiceAiNotificationCategory } from '@/services/api/generated/treatmentRecordRequestsService';

interface MRCategoryBadgeProps {
  category: VoiceAiNotificationCategory | null;
  lastCallAt: string | null;
}

const categoryConfig: Record<
  VoiceAiNotificationCategory,
  {
    label: string;
    icon: React.ElementType;
    bgColor: string;
    textColor: string;
    iconColor: string;
  }
> = {
  progress_made: {
    label: 'Progress Made',
    icon: CheckCircleIcon,
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
    iconColor: 'text-green-500',
  },
  action_needed: {
    label: 'Action Needed',
    icon: ExclamationTriangleIcon,
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-700',
    iconColor: 'text-amber-500',
  },
  auto_retry: {
    label: 'Auto-Retry Scheduled',
    icon: ArrowPathIcon,
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-700',
    iconColor: 'text-blue-500',
  },
};

export const MRCategoryBadge: React.FC<MRCategoryBadgeProps> = ({
  category,
  lastCallAt,
}) => {
  if (!category) {
    return null;
  }

  const config = categoryConfig[category];
  const Icon = config.icon;

  const formattedDate = lastCallAt
    ? new Date(lastCallAt).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : null;

  return (
    <div className="flex items-center justify-between">
      <div
        className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md ${config.bgColor}`}
      >
        <Icon className={`h-4 w-4 ${config.iconColor}`} />
        <span className={`text-xs font-semibold uppercase ${config.textColor}`}>
          {config.label}
        </span>
      </div>
      {formattedDate && (
        <span className="text-xs text-gray-500">{formattedDate}</span>
      )}
    </div>
  );
};
